import {
    ProductDetailGalleryActions,
    ProductDetailGalleryActionsInfoFallback,
} from './product-detail-gallery-actions';
import { ProductDetailGalleryCarousel } from './product-detail-gallery-carousel';
import { ProductDetailGalleryMainImage } from './product-detail-gallery-main-image';
import { ProductDetailGalleryWrapper } from './product-detail-gallery-wrapper';
import { ProductDetailRecommendedCarousel } from './product-detail-recommended-carousel';
import { ProductDetailProvider, type ProductDetailProviderProps } from './provider';

const ProductDetailPage = (props: ProductDetailProviderProps) => (
    <ProductDetailProvider {...props} isChangingByURL />
);

export default ProductDetailPage;
export { ProductDetailInfo as Info } from './product-detail-info';
export { ProductDetailAddons as Addons } from './product-detail-addons';
export { ProductDetailDetails as Details } from './product-detail-details';

export const Gallery = Object.assign(ProductDetailGalleryWrapper, {
    MainImage: ProductDetailGalleryMainImage,
    Carousel: ProductDetailGalleryCarousel,
    Actions: ProductDetailGalleryActions,
    ActionsInfoFallback: ProductDetailGalleryActionsInfoFallback,
});

export const Recommended = Object.assign(ProductDetailRecommendedCarousel, {});
